<script setup lang="ts">
	defineProps<{
		show: boolean
		termsCondition?: string[]
	}>()
	const navigateToTerms = () => {
		navigateTo('https://mycovergenius.com/terms-and-conditions', {
			open: {
				target: '_blank',
				windowFeatures: {
					width: 500,
					height: 500
				}
			}
		})
	}
	const emit = defineEmits(['update:show', 'change'])

	const store = useStore()
	const terms = computed(() => {
		return store.$state['terms-and-condition'] as string[]
	})
</script>

<template>
	<dialogs :show="show" modal-class="max-w-[550px]" type="warning" close-on-bg @change="emit('update:show', false)">
		<div class="mb-10 flex justify-center">
			<div class="light-shadow inline-flex h-[80px] w-[80px] items-center justify-center rounded-full border">
				<lazy-tools-icon dir="fill" icon="warning" :height="44.8" :width="44.8" path-class="fill-warning-400" />
			</div>
		</div>

		<div
			class="justify- flex min-h-[255px] w-full max-w-[563px] flex-col items-center bg-gray-50 px-4 py-3 text-left"
		>
			<h3 class="py-4 text-base font-medium text-primary-2 sm:text-[24px]"> Terms and Conditions </h3>
			<ul v-if="Array.isArray(termsCondition || terms)" class="mt-2 list-item px-4">
				<li
					v-for="(term, index) in termsCondition || terms"
					:key="index"
					class="mb-5 flex items-center gap-x-3 text-sm font-medium leading-[22px] tracking-wide text-gray-500"
				>
					<span class="block h-[6px] w-[6px] flex-none rounded-full bg-purple-400 tracking-wide" />
					<span>{{ term }}</span>
				</li>
				<li class="mb-5 list-outside pl-2 text-sm font-medium text-gray-500">
					<button
						class="border-b-[2px] border-dotted border-primary-2 pb-1 text-sm font-medium tracking-wide text-primary-2"
						target="_blank"
						@click="navigateToTerms"
					>
						View full terms and conditions
					</button>
				</li>
			</ul>
		</div>
		<template #button>
			<div></div>
		</template>
	</dialogs>
</template>
